function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var _require = require('./summary-cache'),
  summaryBucketKey = _require.summaryBucketKey,
  listingTeaserSelector = _require.listingTeaserSelector;
var PHASE = {
  SUBMITTED: 'submitted',
  CONFIRMING: 'confirming',
  FULFILLING: 'fulfilling',
  COMPLETE: 'complete',
  DISMISSED: 'dismissed'
};
var NFT_POLL_MS = 2000;

/**
 * Tracks outstanding Store purchases for the current browser session.
 * Owns local listing-hide state, wallet arrival detection, and emits
 * `store-purchase-lifecycle` on changes.
 *
 * Future: multiple concurrent purchases, retries, archive sold-state updates.
 */
var PurchaseLifecycle = /*#__PURE__*/function () {
  function PurchaseLifecycle(app, mod) {
    var _this = this;
    _classCallCheck(this, PurchaseLifecycle);
    this.app = app;
    this.mod = mod;
    this.purchases = [];
    this.hidden = {};
    this._nftPollTimer = null;
    this._checkingWallet = false;
    this.app.connection.on('wallet-updated', function () {
      // Wallet already ran updateNFTList; only inspect options here.
      void _this.checkWalletForArrival({
        sync: false
      });
    });
    this.app.connection.on('on-nft-received', function (payload) {
      _this.onNftReceived(payload);
    });
    this.app.connection.on('store-new-block', function () {
      void _this.checkWalletForArrival();
    });
  }

  /**
   * Begin tracking a purchase after the tx is submitted.
   * Hides the listing locally and notifies listeners.
   */
  return _createClass(PurchaseLifecycle, [{
    key: "begin",
    value: function begin() {
      var _summary$price, _summary$returnTitle;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$summary = _ref.summary,
        summary = _ref$summary === void 0 ? null : _ref$summary,
        _ref$purchaseTxSignat = _ref.purchaseTxSignature,
        purchaseTxSignature = _ref$purchaseTxSignat === void 0 ? '' : _ref$purchaseTxSignat,
        _ref$quantity = _ref.quantity,
        quantity = _ref$quantity === void 0 ? 1 : _ref$quantity;
      if (!(summary !== null && summary !== void 0 && summary.nft_id) || !purchaseTxSignature) {
        return null;
      }
      this.hideListing(summary);
      var purchase = {
        id: "".concat(purchaseTxSignature, ":").concat(Date.now()),
        nft_id: String(summary.nft_id),
        price: Number((_summary$price = summary.price) !== null && _summary$price !== void 0 ? _summary$price : 0),
        listing_signature: summary.listing_signature || '',
        purchase_tx_signature: purchaseTxSignature,
        title: ((_summary$returnTitle = summary.returnTitle) === null || _summary$returnTitle === void 0 ? void 0 : _summary$returnTitle.call(summary)) || summary.title || 'NFT',
        quantity: Math.max(1, Number(quantity) || 1),
        phase: PHASE.SUBMITTED,
        status: 'Purchasing NFT…',
        detail: 'Transaction submitted.',
        baseline_wallet_count: this.countAllNftsInWallet(),
        baseline_nft_id_count: this.countNftInWallet(summary.nft_id),
        started_at: Date.now(),
        completed_at: 0
      };
      this.purchases.push(purchase);
      this.setPhase(purchase.id, PHASE.CONFIRMING, {
        status: 'Purchasing NFT…',
        detail: 'Waiting for next block…'
      });
      this.startNftPolling();
      if (typeof siteMessage === 'function') {
        siteMessage("Purchasing ".concat(purchase.title, "\u2026"), 4000);
      }
      this.app.connection.emit('store-render-listings');
      return purchase;
    }
  }, {
    key: "hideListing",
    value: function hideListing(summary) {
      if (!(summary !== null && summary !== void 0 && summary.nft_id)) {
        return;
      }
      var keys = this.listingHideKeys(summary);
      var _iterator = _createForOfIteratorHelper(keys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _summary$price2;
          var key = _step.value;
          this.hidden[key] = {
            nft_id: String(summary.nft_id),
            price: Number((_summary$price2 = summary.price) !== null && _summary$price2 !== void 0 ? _summary$price2 : 0),
            listing_signature: summary.listing_signature || '',
            hidden_at: Date.now()
          };
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var selector = listingTeaserSelector(summary);
      if (selector) {
        document.querySelectorAll(selector).forEach(function (card) {
          return card.remove();
        });
      }
    }
  }, {
    key: "listingHideKeys",
    value: function listingHideKeys(summary) {
      var keys = [];
      var bucket = summaryBucketKey(summary.nft_id, summary.price);
      keys.push("bucket:".concat(bucket));
      if (summary.listing_signature) {
        keys.push("sig:".concat(summary.listing_signature));
      }
      keys.push("nft:".concat(String(summary.nft_id)));
      return keys;
    }
  }, {
    key: "isListingHidden",
    value: function isListingHidden(summary) {
      var _this2 = this;
      if (!(summary !== null && summary !== void 0 && summary.nft_id)) {
        return false;
      }
      return this.listingHideKeys(summary).some(function (key) {
        return !!_this2.hidden[key];
      });
    }
  }, {
    key: "findById",
    value: function findById() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.purchases.find(function (p) {
        return p.id === id;
      }) || null;
    }
  }, {
    key: "findByPurchaseTx",
    value: function findByPurchaseTx() {
      var signature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!signature) {
        return null;
      }
      return this.purchases.find(function (p) {
        return p.purchase_tx_signature === signature && p.phase !== PHASE.DISMISSED;
      }) || null;
    }
  }, {
    key: "findByNftId",
    value: function findByNftId() {
      var nft_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var id = String(nft_id || '');
      if (!id) {
        return null;
      }
      return this.purchases.find(function (p) {
        return p.nft_id === id && p.phase !== PHASE.COMPLETE && p.phase !== PHASE.DISMISSED;
      }) || null;
    }

    /** Active purchase the UI should surface (pending or just completed). */
  }, {
    key: "returnActivePurchase",
    value: function returnActivePurchase() {
      var pending = this.purchases.find(function (p) {
        return p.phase === PHASE.SUBMITTED || p.phase === PHASE.CONFIRMING || p.phase === PHASE.FULFILLING;
      });
      if (pending) {
        return pending;
      }
      return this.purchases.find(function (p) {
        return p.phase === PHASE.COMPLETE;
      }) || null;
    }
  }, {
    key: "hasPendingPurchases",
    value: function hasPendingPurchases() {
      return this.purchases.some(function (p) {
        return p.phase === PHASE.SUBMITTED || p.phase === PHASE.CONFIRMING || p.phase === PHASE.FULFILLING;
      });
    }
  }, {
    key: "setPhase",
    value: function setPhase(id, phase) {
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref2$status = _ref2.status,
        status = _ref2$status === void 0 ? '' : _ref2$status,
        _ref2$detail = _ref2.detail,
        detail = _ref2$detail === void 0 ? '' : _ref2$detail;
      var purchase = this.findById(id);
      if (!purchase) {
        return null;
      }
      purchase.phase = phase;
      if (status) {
        purchase.status = status;
      }
      if (detail) {
        purchase.detail = detail;
      }
      if (phase === PHASE.COMPLETE) {
        purchase.completed_at = Date.now();
        if (!this.hasPendingPurchases()) {
          this.stopNftPolling();
        }
      }
      if (phase === PHASE.DISMISSED && !this.hasPendingPurchases()) {
        this.stopNftPolling();
      }
      this.emit(purchase);
      return purchase;
    }
  }, {
    key: "markPaymentConfirmed",
    value: function markPaymentConfirmed() {
      var purchaseTxSignature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var purchase = this.findByPurchaseTx(purchaseTxSignature);
      if (!purchase) {
        return null;
      }
      if (purchase.phase === PHASE.COMPLETE || purchase.phase === PHASE.DISMISSED || purchase.phase === PHASE.FULFILLING) {
        return purchase;
      }
      var updated = this.setPhase(purchase.id, PHASE.FULFILLING, {
        status: 'Payment confirmed',
        detail: 'Waiting for your NFT to arrive…'
      });
      this.startNftPolling();
      this.checkWalletForArrival();
      return updated;
    }
  }, {
    key: "markComplete",
    value: function markComplete(purchase) {
      if (!purchase || purchase.phase === PHASE.COMPLETE) {
        return purchase || null;
      }
      var updated = this.setPhase(purchase.id, PHASE.COMPLETE, {
        status: 'NFT received!',
        detail: 'Your NFT has arrived in your wallet.'
      });
      if (typeof siteMessage === 'function') {
        siteMessage("NFT received: ".concat(purchase.title), 5000);
      }
      return updated;
    }
  }, {
    key: "dismiss",
    value: function dismiss() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var purchase = id ? this.findById(id) : this.returnActivePurchase();
      if (!purchase) {
        return null;
      }
      return this.setPhase(purchase.id, PHASE.DISMISSED, {
        status: '',
        detail: ''
      });
    }
  }, {
    key: "countAllNftsInWallet",
    value: function countAllNftsInWallet() {
      var _this$app$options;
      var list = ((_this$app$options = this.app.options) === null || _this$app$options === void 0 || (_this$app$options = _this$app$options.wallet) === null || _this$app$options === void 0 ? void 0 : _this$app$options.nfts) || [];
      return list.length;
    }
  }, {
    key: "countNftInWallet",
    value: function countNftInWallet() {
      var _this$app$options2;
      var nft_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var id = String(nft_id || '');
      if (!id) {
        return 0;
      }
      var list = ((_this$app$options2 = this.app.options) === null || _this$app$options2 === void 0 || (_this$app$options2 = _this$app$options2.wallet) === null || _this$app$options2 === void 0 ? void 0 : _this$app$options2.nfts) || [];
      var count = 0;
      var _iterator2 = _createForOfIteratorHelper(list),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _rec$id;
          var rec = _step2.value;
          if (String((_rec$id = rec === null || rec === void 0 ? void 0 : rec.id) !== null && _rec$id !== void 0 ? _rec$id : '') === id) {
            var _ref3, _rec$slip1$amount, _rec$slip;
            var amount = Number((_ref3 = (_rec$slip1$amount = rec === null || rec === void 0 || (_rec$slip = rec.slip1) === null || _rec$slip === void 0 ? void 0 : _rec$slip.amount) !== null && _rec$slip1$amount !== void 0 ? _rec$slip1$amount : rec === null || rec === void 0 ? void 0 : rec.amount) !== null && _ref3 !== void 0 ? _ref3 : 1);
            count += Number.isFinite(amount) && amount > 0 ? amount : 1;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return count;
    }
  }, {
    key: "hasWalletCountIncreased",
    value: function hasWalletCountIncreased(purchase) {
      if (!purchase) {
        return false;
      }
      return this.countAllNftsInWallet() >= (purchase.baseline_wallet_count || 0) + 1;
    }

    /**
     * True when the wallet NFT list has grown since tracking began, or when
     * the listing nft_id count has increased (fallback).
     */
  }, {
    key: "hasReceivedNft",
    value: function hasReceivedNft(purchase) {
      if (!purchase) {
        return false;
      }
      if (this.hasWalletCountIncreased(purchase)) {
        return true;
      }
      if (!purchase.nft_id) {
        return false;
      }
      var current = this.countNftInWallet(purchase.nft_id);
      var needed = (purchase.baseline_nft_id_count || 0) + (purchase.quantity || 1);
      return current >= needed;
    }
  }, {
    key: "onNftReceived",
    value: function onNftReceived(payload) {
      var nft_id = (payload === null || payload === void 0 ? void 0 : payload.nft_id) || (payload === null || payload === void 0 ? void 0 : payload.id) || '';
      if (!nft_id) {
        return;
      }
      if (!this.findByNftId(nft_id)) {
        return;
      }
      this.checkWalletForArrival();
    }
  }, {
    key: "startNftPolling",
    value: function startNftPolling() {
      var _this3 = this;
      if (this._nftPollTimer) {
        return;
      }
      this._nftPollTimer = setInterval(function () {
        _this3.checkWalletForArrival();
      }, NFT_POLL_MS);
    }
  }, {
    key: "stopNftPolling",
    value: function stopNftPolling() {
      if (this._nftPollTimer) {
        clearInterval(this._nftPollTimer);
        this._nftPollTimer = null;
      }
    }
  }, {
    key: "checkWalletForArrival",
    value: function () {
      var _checkWalletForArrival = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _ref4,
          _ref4$sync,
          sync,
          _this$app$wallet,
          _iterator3,
          _step3,
          purchase,
          _args = arguments,
          _t,
          _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _ref4 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref4$sync = _ref4.sync, sync = _ref4$sync === void 0 ? true : _ref4$sync;
              if (!(this._checkingWallet || !this.hasPendingPurchases())) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this._checkingWallet = true;
              _context.p = 2;
              if (!(sync && typeof ((_this$app$wallet = this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.updateNFTList) === 'function')) {
                _context.n = 3;
                break;
              }
              _context.n = 3;
              return this.app.wallet.updateNFTList();
            case 3:
              _iterator3 = _createForOfIteratorHelper(this.purchases);
              _context.p = 4;
              _iterator3.s();
            case 5:
              if ((_step3 = _iterator3.n()).done) {
                _context.n = 8;
                break;
              }
              purchase = _step3.value;
              if (!(purchase.phase === PHASE.COMPLETE || purchase.phase === PHASE.DISMISSED)) {
                _context.n = 6;
                break;
              }
              return _context.a(3, 7);
            case 6:
              if (this.hasReceivedNft(purchase)) {
                this.markComplete(purchase);
              }
            case 7:
              _context.n = 5;
              break;
            case 8:
              _context.n = 10;
              break;
            case 9:
              _context.p = 9;
              _t = _context.v;
              _iterator3.e(_t);
            case 10:
              _context.p = 10;
              _iterator3.f();
              return _context.f(10);
            case 11:
              _context.n = 13;
              break;
            case 12:
              _context.p = 12;
              _t2 = _context.v;
              console.warn('Store: wallet NFT check failed', (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || _t2);
            case 13:
              _context.p = 13;
              this._checkingWallet = false;
              return _context.f(13);
            case 14:
              return _context.a(2);
          }
        }, _callee, this, [[4, 9, 10, 11], [2, 12, 13, 14]]);
      }));
      function checkWalletForArrival() {
        return _checkWalletForArrival.apply(this, arguments);
      }
      return checkWalletForArrival;
    }()
  }, {
    key: "emit",
    value: function emit(purchase) {
      this.app.connection.emit('store-purchase-lifecycle', purchase);
    }
  }]);
}();
PurchaseLifecycle.PHASE = PHASE;
module.exports = PurchaseLifecycle;